import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const root = css`
  max-block-size: 100%;
`

export const content = css`
  block-size: 100%;
`

export const trail = css`
  padding: ${spacing(1)};
`
